import React from "react";
import { useNavigate } from "react-router-dom";
import { Offer } from "../utils/API";

const RecommendedBrands: React.FC<{ recommendedBrandsData: Offer[] }> = ({
  recommendedBrandsData,
}) => {
  const navigate = useNavigate();

  const handleJumpToBranddiscountcode = (offer_id: string, store: string) => {
    navigate(`/branddiscountcode?offer_id=${offer_id}&store=${store}`);
  };

  return (
    <>
      <section className=" w-full max-w-[1200px] mx-auto flex justify-center items-center">
        <div className="w-full category-grocery-and-food-coupons">
          <div className="max-w-[1300px] mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-5 gap-x-[23px] md:gap-[30px] mx-auto px-[26px] md:px-[100px] border-5 border-teal-300">
              {recommendedBrandsData?.map((item) => {
                const clamp = (s: string, n: number) =>
                  s.length > n ? `${s.slice(0, n)}…` : s;
                const logoUrl = (item.brand_logo || "")
                  .replace("[size]", "200")
                  .replace("[format]", "png");
                return (
                  <div
                    key={item.offer_id}
                    className="coupon-item flex-col shadow-coupon py-2.5 px-3.5 md:py-4 md:px-6 max-w-[280px] h-[210px] md:h-[220px] lg:h-[250px] xl:h-[300px] cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-primary-500/20 relative overflow-hidden group"
                    style={{
                      background:
                        "url(/images/yellow-ticket.png)  no-repeat center center / 100% 100% ",
                    }}
                    onClick={() =>
                      handleJumpToBranddiscountcode(item.offer_id, item.store)
                    }
                  >
                    {/* <div className="w-full h-full text-white"> */}
                    <div className="w-full h-full flex flex-col justify-center items-center gap-1 md:gap-1.5 lg:gap-2 xl:gap-2">
                      {/* <div className="flex flex-col items-center justify-center w-full h-full md:px-10 md:pt-[56px] md:pb-9 relative"> */}
                      <div className="flex flex-col justify-center items-center space-y-2 rounded-[10px] transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
                        <img
                          src={logoUrl}
                          alt={item.categories}
                          referrerPolicy="no-referrer"
                          crossOrigin="anonymous"
                          onError={(e) => {
                            const target = e.currentTarget as HTMLImageElement;
                            target.src = "/images/white.png";
                          }}
                          // className="w-[60px] h-[60px] md:w-[120px] md:h-[120px] rounded-[10px] border-[2px] border-red-500 bg-white object-contain mb-1 transform-gpu md:group-hover:scale-110 md:group-hover:rotate-3 transition-all duration-300"
                          className="w-[60px] h-[60px] md:w-[70px] md:h-[70px] lg:w-[80px] lg:h-[80px] xl:w-[98px] xl:h-[98px] rounded-[10px] object-contain border-[2px] border-red-500 px-1 bg-white"
                        />
                        <div
                          // className="text-lg md:text-2xl font-black text-primary-0 md:mt-5 line-clamp-1"
                          className="text-[24px] leading-8 md:text-[26px] md:leading-9 lg:text-[30px] lg:leading-10 xl:text-[36px] xl:leading-[52px] font-black text-center line-clamp-1 text-white"
                          data-astro-cid-wfe7xcno=""
                          style={{
                            textShadow: "0 3px 0px rgba(0, 0, 0, 0.4)",
                          }}
                        >
                          {/* {item.store} */}
                          {clamp(item.store, 8)}
                        </div>
                        <div
                          // className="text-xs md:text-xl text-primary-0 font-black"
                          className="text-base md:text-lg md:leading-6 lg:text-xl lg:leading-7 xl:text-2xl xl:leading-8 font-semibold leading-5 text-center line-clamp-1 text-white"
                          style={{
                            textShadow: " 0 2px 0px rgba(0, 0, 0, 0.5)",
                          }}
                          data-astro-cid-wfe7xcno=""
                        >
                          {item.label}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RecommendedBrands;
